import { Button } from '@/components/base/button'
import { Dialog, DialogActions, DialogBody, DialogTitle, ShowProps } from '@/components/base/dialog'
import { useEffect, useState } from 'react'
import { AccommodationQuery } from './__generated__/show_query'
import { AccommodationQuery as Query } from './show_query'
import { useQuery } from '@apollo/client'
import { Inline as Loading } from '@/components/loading'
import { Inline as Error } from '@/components/error'
import { Subheading } from '@/components/base/heading'
import { MapPinIcon } from '@heroicons/react/24/solid'
import { DeleteDialog } from '@/components/delete_dialog'
import { Mutation as DeleteMutation } from '@/components/accommodation/delete_mutation'
import { Query as TableQuery } from '@/components/accommodation/table_query'
import { EditDialog } from './edit_dialog'
import { Accordion } from '../accordion'
import { Table as ContactTable } from '@/components/accommodation_contact/table'
import { Table as RoomTypeTable } from '@/components/accommodation_room_type/table'

type AccommodationType = AccommodationQuery['accommodations']['nodes'][0]

export const ShowDialog = ({ id, open, setOpen }: ShowProps) => {
  const [openEdit, setOpenEdit] = useState(false)
  const [openDelete, setOpenDelete] = useState(false)
  const [accommodation, setAccommodation] = useState<AccommodationType | null>(null)

  const { data, loading, error } = useQuery<AccommodationQuery>(Query, { variables: { filters: { idEq: id } } })

  useEffect(() => {
    if (!data || !id) { return }

    setAccommodation(data.accommodations.nodes[0])
  }, [id, data])

  const onEdit = () => {
    setOpenEdit(true)
  }
  const onDelete = () => {
    setOpenDelete(true)
  }

  const onDeleteSuccess = () => {
    setOpenDelete(false)
    setOpen(false)
  }

  return (
    <>
      <Dialog open={open} size="7xl" onClose={setOpen}>
        <DialogTitle>
          { loading || !accommodation
            ? <Loading />
            : <div className="flex flex-row justify-between">
              <div>
                <span className="flex flex-row gap-4 items-center pb-6">
                  { accommodation.name }
                </span>
                <span className="flex flex-row gap-2 items-center">
                  <MapPinIcon className="h-6 w-6" />
                  <Subheading>{ accommodation.address }</Subheading>
                </span>
              </div>
            </div> }
        </DialogTitle>
        <DialogBody>
          { error && <Error message={error.message} />}
          { accommodation && (
            <>
              <div className="pb-6">
                <Accordion title="Contacts">
                  <ContactTable accommodationId={accommodation.id} />
                </Accordion>
              </div>
              <Accordion title="Room type">
                <RoomTypeTable accommodationId={accommodation.id} />
              </Accordion>
            </>
          )}
        </DialogBody>
        <DialogActions>
          { accommodation && <Button color="amber" onClick={onEdit}>Edit</Button> }
          { accommodation && <Button color="red" onClick={onDelete}>Delete</Button> }
        </DialogActions>
      </Dialog>
      { accommodation && <EditDialog accommodation={accommodation} open={openEdit} setOpen={setOpenEdit} /> }
      {
        accommodation &&
          <DeleteDialog
            id={accommodation.id}
            mutation={DeleteMutation}
            open={openDelete}
            refetchQueries={[TableQuery]}
            setOpen={setOpenDelete}
            onSuccess={onDeleteSuccess}
          />
      }
    </>
  )
}
